import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CustomToastrService } from 'src/app/demo/service/custom-toastr.service';
import { LanguageService } from 'src/app/demo/service/language.service';
@Component({
    selector: 'app-custom-toastr',
    templateUrl: './custom-toastr.component.html',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    styleUrl: './custom-toastr.component.scss',
})
export class CustomToastrComponent {
    @Input() message: string = '';
    @Input() variant: 'success' | 'info' | 'error' | 'warning' = 'success'; // Default to success
    isVisible: boolean = false;
    selectedLanguage: string = '';

    constructor(
        private toastrService: CustomToastrService,
        private translate: TranslateService,
        private languageService: LanguageService
    ) {}

    ngOnInit() {
        this.toastrService.setToastrComponent(this);
        this.initializeLocale();
    }

    initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            this.setLanguage(this.selectedLanguage);
        });
    }

    setLanguage(language: string) {
        this.translate.use(language);
        this.languageService.setLanguage(language);
    }

    show(
        message: string,
        variant: 'success' | 'info' | 'error' | 'warning' = 'success',
        duration: number = 1000
    ) {
        this.message = message;
        this.variant = variant;
        this.isVisible = true;

        setTimeout(() => {
            this.isVisible = false;
        }, duration);
    }

    close() {
        this.isVisible = false;
    }
}
